// googleAuth.js

const googleAuthClient = window.google.accounts.oauth2.initCodeClient({
    client_id: process.env.REACT_APP_OAUTH_CLIENTID,
    scope: process.env.REACT_APP_OAUTH_SCOPE,
    ux_mode: 'popup',
    callback: async (response) => {

        // console.log(response)
        // Assuming the response contains the code you need to send to the Django backend
        const code = response.code;

        // Define the URL of your Django token endpoint
        const tokenUrl = `${process.env.REACT_APP_API_URL}token`;

        // Make a POST request to the token endpoint
        await fetch(tokenUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({code: code}),
        })
            .then(response => response.json())
            .then(data => {
                // console.log('Success:', data);
                // localStorage.setItem("username", data["username"]);
                localStorage.setItem("refresh", data["refresh"]);
                localStorage.setItem("access", data["access"]);
                window.location.reload();
            })
            .catch((error) => {
               // console.error('Error:', error);
            });

        // Backend.
        // console.log(loginResponse)
        // const xhr = new XMLHttpRequest();
        // xhr.open('POST', code_receiver_uri, true);
        // xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        // // Set custom header for CSRF
        // xhr.setRequestHeader('X-Requested-With', 'XmlHttpRequest');
        // xhr.onload = function() {
        //   console.log('Auth code response: ' + xhr.responseText);
        // };
        // xhr.send('code=' + response.code);

    },
});

export default googleAuthClient;







